import { useEffect, useState } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { ReviewBoardItem, SectionDetailType } from '../../@types/home'
import { getReviewBoard, getSectionsDetail } from '../../api/home'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { useAppContext } from '../provider/AppProvider'
import { MemberReviewItem } from './MemberReviewItem'

export default function MemberReview({ el, index }: { el: any; index: number }) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [reviewItem, setReviewItem] = useState<ReviewBoardItem[]>([])
  const { isAppView } = useAppContext()

  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [])

  useEffect(() => {
    const fetchReviewBoard = async () => {
      try {
        const res = await getReviewBoard()
        const filteredItems = res.data.items.filter((el: any) => Number(el.reviewRate) > 4)
        setReviewItem(filteredItems) // 상태를 한 번만 업데이트
      } catch (err) {
        console.log(err)
      }
    }

    fetchReviewBoard()
  }, [])
  return (
    <>
      <div
        className='member_review'
        onClick={(): void => {
          const gtmNavigateClick: DataLayerArgs = {
            dataLayer: {
              event: 'select_content',
              event_info: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            },
          }
          if (isAppView) {
            sendSetAppsflyerEvent({
              eventName: 'select_content',
              eventType: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            })
          } else {
            TagManager.dataLayer(gtmNavigateClick)
          }
        }}
      >
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain}</strong>
          </p>
        </div>
        <div className='member_review_list'>
          <ul>
            {reviewItem?.slice(0, 3)?.map((el: any) => {
              return <MemberReviewItem el={el} key={el.reviewNo}></MemberReviewItem>
            })}
          </ul>
        </div>
        {index !== 0 && <hr />}
      </div>
    </>
  )
}
